import React from 'react';
import './quote.scss';
import quoteMark from '../../assets/quotemark.svg';

function Quote({ data }) {
  const { photo, copy, author, title } = data;
  return (
    <div className={photo ? 'quote quote--photo' : 'quote'}>
      <img className="quote__mark quote__mark-l" src={quoteMark} alt="" />
      <div className="quote-contents">
        {photo && (
          <div className="quote__photo">
            <img src={photo} alt={`Portrait of ${author}`} />
          </div>
        )}

        <div className={photo ? 'quote__text quote__text--photo' : 'quote__text'}>
          <img className="quote__mark quote__mark-s" src={quoteMark} alt="" />
          <blockquote>{copy}</blockquote>
          <div className="quote__author">
            <span className="bold">{author},</span> {title}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Quote;
